import styles from "../../styles/toggle2.module.scss";
import { If } from "./control-statements";

export default function Toggle2({ title, id, checked, onChange, reverse, showText }) {
  return (
    <>
      <If cond={reverse}>
        <div className="d-flex align-center gap-15">
          <div className={styles.toggleContainer}>
            <input id={id} type="checkbox" checked={checked} readOnly />
            <label className={styles.toggle} htmlFor={id} onClick={onChange}>
              <span />
            </label>
          </div>
          <p className={styles.title}>{title}</p>
        </div>
      </If>
      <If cond={!reverse}>
        <div className="d-flex align-center justify-between">
          <p className={styles.title}>{title}</p>
          <div className={styles.toggleContainer}>
            <input id={id} type="checkbox" checked={checked} readOnly />
            <label className={styles.toggle} htmlFor={id} onClick={onChange}>
              <span />
            </label>
          </div>
          {showText && <p className={styles.text}>{checked ? "Sim" : "Não"}</p>}
        </div>
      </If>
    </>
  );
}
